export * from './ort-kategories.page';
export * from './ort-kategories.page.resolver';
